import { forwardRef, ReactElement, createElement, FC } from 'react';

interface InputMaskChildrenWrapperProps {
  children: ReactElement;
}

const InputMaskChildrenWrapper: FC<InputMaskChildrenWrapperProps> = forwardRef(
  function InputMaskChildrenWrapper({ children, ...props }, ref) {
    return createElement(children.type, {
      ...(children.props as Record<string, unknown>),
      ...props,
      ref,
    });
  },
);

export default InputMaskChildrenWrapper;
